import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import ChecklistItem from '@repo/datalayer/store/models/ChecklistItem'
import { Image, Video } from 'lucide-react'
import { ReactElement, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export function FileViewDialog({
  item,
  useIcon,
}: {
  item: ChecklistItem
  useIcon?: boolean
}) {
  const [open, setOpen] = useState(false)
  const [fileUrl, setFileUrl] = useState<string | null>(item.fileUrl || null)
  const { t } = useTranslation()
  const isVideo = item.filetype?.match('video/')

  useEffect(() => {
    if (item.fileUrl) return
    item.getFileUrl().then((data) => {
      setFileUrl(data.url)
    })
  }, [item])

  let label: ReactElement | string = isVideo
    ? t('checklists.viewVideo')
    : t('checklists.viewImage')

  if (useIcon) {
    label = isVideo ? <Video size={20} /> : <Image size={20} />
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button data-test-id="checklist-item-file-view" size="sm" variant="secondary">
          {label}
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px] rounded-2xl">
        <DialogHeader>
          <DialogTitle>{item.name}</DialogTitle>
          <DialogDescription></DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4 max-h-[80vh] max-w-[90vw] overflow-auto">
          {fileUrl && item.filetype?.match('image/') && (
            <img src={fileUrl} className="w-full h-auto" />
          )}
          {fileUrl && item.filetype?.match('video/') && (
            <video autoPlay src={fileUrl} controls className="w-full h-auto" />
          )}
          {!fileUrl && 'Loading'}
        </div>
        <DialogFooter className="!justify-center">
          <Button
            variant="secondary"
            type="button"
            onClick={() => setOpen(false)}
          >
            {t('close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
